import React from 'react';
import { ProductAffinity } from '../customerDetailsTypes';
import styles from './ProductAffinityCard.module.css';

interface ProductAffinityCardProps {
  items: ProductAffinity[];
}

export const ProductAffinityCard: React.FC<ProductAffinityCardProps> = ({ items }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Product Affinity</h3>
        <span className={styles.headerIcon}>↗</span>
      </div>
      <div className={styles.list}>
        {items.map((item) => (
          <div key={item.id} className={styles.row}>
            <div>
              <p className={styles.name}>{item.name}</p>
              <p className={styles.cadence}>{item.cadence}</p>
            </div>
            <span className={styles.units}>{item.avgUnits}</span>
          </div>
        ))}
      </div>
      <button className={styles.bundleBtn}>Suggest Bundle Deals</button>
    </div>
  );
};
